import { ExpenseCreateForm } from './ExpenseCreateForm'
import { ExpenseUpdateForm } from './ExpenseUpdateForm'
import { Modal } from '@/components/custom/modal'

interface ExpenseFormProps {
  id?: string | null
  type: 'add' | 'edit'
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}

export function ExpenseForm({
  id,
  type,
  trigger,
  open,
  onClose,
}: ExpenseFormProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      trigger={trigger}
      title={type === 'edit' ? 'Edit Expense' : 'Add Expense'}
      direction="right"
      contentClassName="min-w-[98vw] lg:min-w-fit"
    >
      {type === 'edit' ? (
        <ExpenseUpdateForm expenseId={id || null} onClose={onClose} />
      ) : (
        <ExpenseCreateForm internal onClose={onClose} />
      )}
    </Modal>
  )
}
